// DroppableCategory.tsx
import React from "react";
import { useDrop } from "react-dnd";
import { HydratedBook } from "./stateMachine/gameStateMachine";
import { Category } from "./nyt";

function comparesResults(
  booksCategorizedByUser: string[],
  booksCategorizedbyAI: string[]
): {
  guessedButNotCorrect: string[];
  correctButNotGuessed: string[];
  guessedCorrect: string[];
} {
  const set1 = new Set(booksCategorizedByUser);
  const set2 = new Set(booksCategorizedbyAI);

  const inFirstNotSecond = new Set(
    [...set1].filter((element) => !set2.has(element))
  );
  const inSecondNotFirst = new Set(
    [...set2].filter((element) => !set1.has(element))
  );
  const inBoth = new Set([...set1].filter((element) => set2.has(element)));

  return {
    guessedButNotCorrect: [...inFirstNotSecond],
    correctButNotGuessed: [...inSecondNotFirst],
    guessedCorrect: [...inBoth],
  };
}

const DroppableCategory = ({
  onDropBook,
  books,
  answers,
}: {
  onDropBook: Function;
  books: HydratedBook[];
  answers?: Category;
}) => {
  const [{ isOver, canDrop }, drop] = useDrop(() => ({
    accept: "book",
    drop: (item, monitor) => onDropBook(item.book),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));

  return (
    <>
      <div ref={drop} className={`book-holder`}>
        {books &&
          books.map((book: HydratedBook) => {
            return (
              <img
                src={book.image}
                id={book.id}
                key={book.id}
                draggable={true}
              />
            );
          })}
      </div>
    </>
  );
};

export default DroppableCategory;
